// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AhAgU","question":"styles_question__2OsHs","inputVisibleButton":"styles_inputVisibleButton__1U-BQ","note":"styles_note__2WGi3"};